import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class ProjectsDataService {

    constructor(private http: HttpClient) {
    }

    // Create new project
    createProject(projectData: object) {
        return this.http.post('agri/crm/createProject', projectData);
    }

    // Get all recruiters
    getAllRecruiters() {
        return this.http.get('agri/crm/getAllRecruiterUsers');
    }

    // Get all clients
    getAllClients() {
        return this.http.get('agri/crm/getAllCompanies');
    }

    // Get all CRM Users
    getAllCRMUsers() {
        return this.http.get('agri/crm/getAllCRMUsers');
    }

    // Get project data
    getProject(projectId: string) {
        return this.http.get('agri/crm/getProject?projectId=' + projectId);
    }

    // Update project
    updateProject(projectId: string, projectData: object) {
        return this.http.put('agri/crm/updateProject?projectId=' + projectId, projectData);
    }

    // Get all projects
    getProjects(page, size, sort, dir, filterData: object) {
        return this.http.post('agri/listProjectFiltered?page=' + (page - 1) + '&size=' + size + '&sort=' + sort + '&dir=' + dir, filterData);
    }

    // Change project status
    changeStatus(projectId:string, status: string) {
        return this.http.put('agri/crm/changeProjectStatus?projectId=' + projectId + '&status=' + status,'');
    }

    // Get contract numbers
    getContracts() {
        return this.http.get('agri/crm/getContractNumbers');
    }

    createJobAfterProject(projectId: any){
        return this.http.post('agri/crm/createJobFromProject?projectId=' + projectId, {});
    }
}
